import React, { useEffect, useState } from "react";
import axios from '../../api/axios';
import { allowedCardsBrands } from "../../constants";

const ApplePay = ({ country, currency, price, description, externalMerchantId, disallowedCardBrands = [], onSuccess, isEmbedded=false }) => {
    const [isShown, setIsShown] = useState(false);
    
    useEffect(() => {
        if (checkSession()) {
            setIsShown(true);
        }
    }, []);

    const getHostDomain = () => {
        if (isEmbedded) {        
            try {
                const referrerUrl = document.referrer;
                return referrerUrl ? new URL(referrerUrl).hostname : window.location.hostname;
            } catch (error) {
                console.error("Error parsing referrer:", error);
                return window.location.hostname;
            }
        } else {        
            return window.location.hostname;
        }
    };
    const checkSession = () => {
        const appleSession = window.ApplePaySession;
        const res = appleSession && appleSession.canMakePaymentsWithActiveCard(externalMerchantId);
        return res;
    }

    const onValidateMerchantEvent = async (event, applePaySession) => {
        const {validationURL} = event;
        const merchantSession = await validateSession(validationURL);
        if (merchantSession) {
            applePaySession.completeMerchantValidation(JSON.parse(merchantSession));
        }
    }

    const onPaymentAuthorizedEvent = async (event, applePaySession) => {
        const tokenData = JSON.stringify(event.payment.token.paymentData);
        try {
            await onSuccess(tokenData);
            applePaySession.completePayment(window.ApplePaySession.STATUS_SUCCESS);
        } catch (error) {
            applePaySession.completePayment(window.ApplePaySession.STATUS_FAILURE);
        }
    }
  
    const validateSession = async (appleUrl) => {
       const hostDomain = getHostDomain();
       
       const payload = {
            domain: hostDomain,       
            appleUrl,
        };
        try {
            const result = await axios.post('/apple/validate-session-with-domain', payload);
            return result.data;
        } catch (error) {
            return null;
        }
    }

    const onPay = () => {
        const applePaySession = new window.ApplePaySession(13, {
            countryCode: country, // - from payment-info, but need to check pay-in-list response
            currencyCode: currency, // - from payment-info, but need to check pay-in-list response
            supportedNetworks: allowedCardsBrands.filter((brand) => !disallowedCardBrands.includes(brand)), // - maybe are returned from payment API 
            merchantCapabilities: ["supports3DS"], // - constant
            total: {
                label: description, // - from payment-info, description
                amount: String(price) // - from payment-info, amount
            }
        });
        applePaySession.begin();

        applePaySession.onvalidatemerchant = (event) => onValidateMerchantEvent(event, applePaySession);
        applePaySession.onpaymentauthorized = (event) => onPaymentAuthorizedEvent(event, applePaySession);
    }
    
    return (
        <div className="alternative-button">
            {isShown &&
                <div aria-hidden="true" className="apple-pay-button apple-pay-button-black"
                    onClick={onPay}></div>
            }
        </div>
    )
}

export default ApplePay;